export default __webpack_public_path__ + "static/media/Cloudspire.fad225b0.jpg";